import { CircularProgress, Stack } from '@mui/material';
import { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { SignupModelHelper } from "../data/SignupModel";
import { SalaryExpectationDto } from '../data/dto/salary-expectation.dto';
import AmarelinhoService from '../services/AmarelinhoService';
import { AmplitudeService } from '../services/AmplitudeService';

export default function PretensaoSalarial(props: any) {
  const [selectedSalary, setSelectedSalary] = useState<SalaryExpectationDto>({ id: 0, description: '', minValue: 0 });
  const [salaryExpectationOptions, setSalaryExpectationOptions] = useState<SalaryExpectationDto[]>([]);
  const [loading, setLoading] = useState(true);

  const [typed, setTyped] = useState(false);
  const [interactions, setInteractions] = useState<InteractionModel[]>([]);

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    AmarelinhoService.listSalaryExpectations().then(salaryExpectationList => {
      if (salaryExpectationList) {
        setSalaryExpectationOptions(salaryExpectationList);
        setTyped(true);
      } else {
        setTimeout(() => {
          setInteractions([...interactions, {
            text: 'Estou com problemas para buscar as opções de pretensão salarial. Favor tente mais tarde.',
            author: InteractionAuthor.AMARELINHO
          }])
          setTyped(false);
        }, 1000);
      }

      setLoading(false);
    })

    // TagManager.dataLayer(dataLayerHelper.pagina('pretensao-salarial', 'curriculo'));
    AmplitudeService.track('Salary Screen')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function saveSalaryExpectation(salary: SalaryExpectationDto) {
    SignupModelHelper.update({ salaryExpectation: salary });
    const signup = SignupModelHelper.get();
    setLoading(true);

    AmarelinhoService.saveSalaryExpectation(signup!).then(result => {
      setLoading(false);
      if (result.success) {
        AmplitudeService.track('Salary Submit', { salary_option: salary.minValue })
        document.location = '#/objetivos-profissionais';
      } else {
        setInteractions([...interactions, {
          text: 'Estou com problemas para salvar sua pretensão salarial. Favor tente mais tarde.',
          author: InteractionAuthor.AMARELINHO
        }])
      }
    });
  }

  function updateSalaryExpectation(id: number) {
    const salary = salaryExpectationOptions.find((se) => se.id === id);
    setSelectedSalary(salary!);
    saveSalaryExpectation(salary!);
  }

  return (
    <>
      <Header step={ 1 } total={ 2 } title="Sua pretensão salarial" previous="#/nacionalidade" finished={ false }></Header>
      <div className="chat-container">
        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter
                          .changeDelay(15)
                          .typeString(`Vamos falar agora dos seus objetivos profissionais.<br /><br />Qual é <strong>sua pretensão salarial</strong> para o seu próximo emprego?`)
                          .callFunction(() => {
                          })
                          .start();
                      } }
                    />
                  </div>
                </div>

                {
                  interactions.map((interaction) => {
                    let objRet;

                    if (interaction.author === InteractionAuthor.AMARELINHO) {
                      objRet = <div className="chat-item" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                        <div className="chat-item-content">
                          <Typewriter
                            onInit={ (typewriter) => {
                              typewriter.changeDelay(15).typeString(interaction.text)
                                .start();
                            } } />
                        </div>
                      </div>

                    } else if (interaction.author === InteractionAuthor.CLIENTE) {
                      objRet = <div className="chat-item chat-item-user" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-user.svg" alt="Usuário" />
                        <div className="chat-item-content">
                          <p>{ interaction.text }</p>
                        </div>
                      </div>
                    }

                    return objRet;
                  })
                }
              </div>
            </div>
          </div>
        </div>

        { (typed || loading) &&
          <footer className="footer-answer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="footer-answer-holder d-flex align-items-center justify-content-between">
                    { loading &&
                      <>
                        <Stack sx={ { color: '#6F5192' } } justifyContent="center" alignItems="center">
                          <CircularProgress color="inherit" />
                        </Stack>
                      </>
                    }
                    { typed && !loading && (
                      <>
                        <select name="" className="select select-salary" id="salary" onChange={ (e) => updateSalaryExpectation(+e.target.value) }
                          value={ selectedSalary.id } >
                          <option>Selecione a pretensão salarial</option>
                          {
                            salaryExpectationOptions.map(salaryOption => (
                              <option key={ salaryOption.id } value={ salaryOption.id }>{ salaryOption.description }</option>
                            ))
                          }
                        </select>
                        <input type="text" name="" id="input" placeholder="Escolha a pretensão salarial" readOnly value={ selectedSalary.description } />
                        <button className="btn-submit" disabled={ !selectedSalary } onClick={ () => saveSalaryExpectation(selectedSalary!) }>
                          <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20L24 10L0.0114286 0L0 7.77778L17.1429 10L0 12.2222L0.0114286 20Z"></path></svg>
                        </button>
                      </>
                    ) }
                  </div>
                </div>
              </div>
            </div>
          </footer>
        }
      </div>
    </>
  );
}

